const state = {
  // Список e-mail
  emails: [],

  // Общее количество e-mail
  total: 0,

  // Флаг показывающий загружается ли сейчас страница с e-mail
  isLoading: false,
};

export default state;
